'use client'
import React from 'react'
import { pageSectionTypes } from './pageSectionTypes'
import { Grid } from '@achieve/ascend'

export function ChildComponentGeneratorClient({
  uiComponent,
  isCrawler = false,
  phoneData,
  ...props
}) {
  const SectionComponent = pageSectionTypes[uiComponent]
  if (!SectionComponent) {
    return null
  }
  return <SectionComponent content={{ ...props, isCrawler }} phoneData={phoneData} />
}

export function GridHandler({ gridContents, columns, phoneData, ...gridProps }) {
  return (gridContents || []).map((gridContent, index) => {
    return (
      <Grid size={{ xs: 12 / columns }} key={`${gridContent?.sys?.id}-${index}`} {...gridProps}>
        <ChildComponentGeneratorClient
          contentTypes={pageSectionTypes}
          uiComponent={gridContent.fields.uiComponent}
          phoneData={phoneData}
          {...gridContent}
        />
      </Grid>
    )
  })
}
